import moment from 'moment';

export default function formatarData(idioma, data, anoCompleto = false) {
  const formatoPadrao = anoCompleto ? 'DD/MM/YYYY' : 'DD/MM/YY';
  const formatoEnUs = anoCompleto ? 'MM/DD/YYYY' : 'MM/DD/YY';

  switch (idioma) {
    case 'pt-br':
      return moment(data).locale('pt-br').format(formatoPadrao);
    case 'en-us':
      return moment(data).locale('en-us').format(formatoEnUs);
    case 'es':
      return moment(data).locale('es').format(formatoPadrao);
    case 'pt-pt':
      return moment(data).locale('pt-pt').format(formatoPadrao);
    case 'it':
      return moment(data).locale('it').format(formatoPadrao);

    default:
      return moment(data).locale('pt-br').format(formatoPadrao);
  }
}
